import { ajax } from "@/config/axios";
import { AJAX_ACTION, NONCE } from "@/utils/constants";
import { useQuery } from "@tanstack/react-query";

type ParentPost = {
    id: number;
    title: string;
};

/**
 * Hook to fetch parent posts (top-level posts with post_parent = 0)
 * Applicable for any hierarchical post type (pages, docs, etc.)
 */
export function useParentPosts(postType: string, enabled = true) {
    const query = useQuery<{ parent_posts: ParentPost[] }>({
        queryKey: ["parent_posts", postType],
        queryFn: () =>
            ajax({
                action: AJAX_ACTION.GET_PARENT_POSTS,
                nonce: NONCE.GET_PARENT_POSTS,
                post_type: postType,
            }),
        enabled,
        staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    });

    return {
        data: query.data?.parent_posts || [],
        isLoading: query.isLoading,
        refetch: query.refetch,
    };
}
